export default function printThermalInvoice(data, printWindow) {
    const { payment } = data;

    const calculateItemTotal = (item) => item.total_price;
    const calculateOrderTotal = (order) =>
        order.items.reduce((sum, item) => sum + calculateItemTotal(item), 0);

    const currentDate = new Date().toLocaleString("ja-JP", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });

    // const printWindow = window.open("", "_blank", "width=400,height=600");

    printWindow.document.write(`
    <html>
      <head>
        <title>Invoice #${payment.id}</title>
        <style>
          @page { size: 80mm auto; margin: 0; }
          body { font-family: monospace; font-size: 12px; padding: 5px; color: #000; width: 80mm; }
          .header { text-align: center; margin-bottom: 10px; }
          .logo img { height: 50px; width: 80px; }
          .divider { border-bottom: 1px dashed #000; margin: 5px 0; }
          table { width: 100%; margin-bottom: 5px; }
          th, td { padding: 2px 0; }
          .item-price { text-align: right !important; }
          .totals { margin-top: 5px; text-align: right; }
          .thank-you { text-align: center; margin-top: 5px; font-weight: bold; }
          .feedback { text-align: center; margin-top: 10px; }
          .feedback img { width: 80px; height: 80px; }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="logo">
            <img src="${window.location.origin}/logo.png" />
          </div>
          <div><strong>ZAMZAM CURRY RESTAURANT</strong></div>
          <div>〒376-0101 Sakura Mall, Midori, Gunma</div>
          <div>Tel: +81-0277-66-9545</div>
          <div>${currentDate}</div>
        </div>

        <div class="divider"></div>
        <p><strong>Invoice #${payment.id}</strong></p>
        ${payment.table_number != 20 ? `<p><strong>Table:</strong> ${payment.table_number}</p>` : `<p><strong>Takeout</strong></p>`}
        <p><strong>Payment:</strong> ${payment.payment_method}</p>
        ${payment.card_number ? `<p>Card: **** **** **** ${payment.card_number}</p>` : ""}

        <div class="divider"></div>

        ${payment.orders.map(order => `
          <p><b>Order #${payment.id}</b></p>
          <table>
            <tbody>
              ${order.items.map(item => `
                <tr>
                  <td>${item.japanese_name}</td>
                  <td>x ${item.quantity}</td>
                  <td class="item-price">¥${calculateItemTotal(item)}</td>
                </tr>
              `).join("")}
            </tbody>
          </table>
          <p style="text-align: right;"><strong>Order Total: ¥${calculateOrderTotal(order)}</strong></p>
                            ${payment.cash_received > 0 ? `
  <p style="text-align: right;"><strong>Cash Received: ¥${payment.cash_received}</strong></p>
  <p style="text-align: right;"><strong>Exchange: ¥${payment.customer_exchange}</strong></p>
` : ""}
          <div class="divider"></div>
        `).join("")}

        <div class="totals">
          <p><strong>Total: ¥${payment.total_amount}</strong></p>
          <p>Discount: ¥${payment.discount}</p>
          <p>Paid: ¥${payment.paid_amount}</p>
        </div>

        <div class="thank-you">Thanks for Visiting Us! またお越しください</div>

        <div class="feedback">
          <p>📝 Feedback</p>
          <img src="${window.location.origin}/feedback.png" />
        </div>
      </body>
    </html>
  `);

    printWindow.document.close();

    const images = printWindow.document.querySelectorAll("img");
    if (images.length > 0) {
        let loaded = 0;
        const done = () => {
            loaded++;
            if (loaded === images.length) {
                printWindow.print();
                printWindow.close();
            }
        };
        images.forEach(img => {
            if (img.complete) done();
            else {
                img.onload = done;
                img.onerror = done;
            }
        });
    } else {
        printWindow.print();
        printWindow.close();
    }
}
